const UPDATE_CHANNEL = 'UPDATE_CHANNEL';

const initialState = {
  channel: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CHANNEL: {
      return { channel: action.payload.channel };
    }
    default:
      return state;
  }
};

export const updateChannel = payload => ({
  type: UPDATE_CHANNEL,
  payload,
});

export default reducer;
